import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, fadeUp } from "./content";

function ServiceCard({ service, className, big }) {
  return (
    <motion.article
      variants={fadeUp}
      className={`group relative overflow-hidden rounded-[8px] border border-surface-alt bg-surface flex flex-col ${className}`}
      data-testid={`service-card-${service.no}`}
    >
      <div className={`relative overflow-hidden ${big ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
        <img
          src={service.image}
          alt={service.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-forest/50 to-transparent opacity-70" />
        <span className="absolute top-5 left-5 font-display text-4xl text-bone/95">{service.no}</span>
        <span className="absolute bottom-5 left-5 font-mono-label text-[0.68rem] uppercase tracking-[0.2em] text-bone/90">
          {service.short}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-8">
        <h3 className="font-display text-2xl md:text-[1.7rem] leading-tight tracking-tight text-forest">
          {service.title}
        </h3>
        <p className="mt-4 text-ink-soft leading-relaxed">{service.body}</p>

        <div className="mt-6 flex flex-wrap gap-2">
          {service.tags.map((t) => (
            <span
              key={t}
              className="rounded-full border border-sage/60 px-3 py-1 font-mono-label text-[0.66rem] uppercase tracking-[0.14em] text-ink-soft"
            >
              {t}
            </span>
          ))}
        </div>

        <a
          href="#contact"
          className="mt-8 inline-flex items-center gap-2 self-start font-medium text-forest hover:text-forest-accent transition-colors duration-200 group/link"
          data-testid={`service-cta-${service.no}`}
        >
          Enquire about this
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
        </a>
      </div>
    </motion.article>
  );
}

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-36" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          className="max-w-3xl mb-16"
        >
          <span className="overline text-ink-soft">What I offer</span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-forest">
            Three ways to keep your practice moving.
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          transition={{ staggerChildren: 0.12 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8"
        >
          <ServiceCard service={SERVICES[0]} className="md:col-span-7" big />
          <ServiceCard service={SERVICES[1]} className="md:col-span-5" />
          <ServiceCard service={SERVICES[2]} className="md:col-span-12" big />
        </motion.div>
      </div>
    </section>
  );
}
